module.exports = {"version":"1.0.0","pipeline":{"name":"pipeline-regionalSelect","title":"省市区选择","type":"qs-other","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-regionalSelect/package.json
// module id = 264
// module chunks = 0